import React from "react";
import { waLink } from "@/config/site";
import { MessageCircle } from "lucide-react";

export function WhatsAppButton({ message }) {
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Atmasamman Group on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-black/25 transition-transform hover:-translate-y-0.5 wa-pulse sm:bottom-6 sm:right-6"
    >
      <MessageCircle className="h-6 w-6" strokeWidth={2.2} />
      <span className="hidden text-sm font-semibold sm:inline">Chat with us</span>
    </a>
  );
}
